import React from 'react';
import { motion } from 'framer-motion';
import { FiHome, FiBriefcase, FiTrendingUp, FiCheckCircle } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import TiltCard from '../common/TiltCard';

const features = [
  "Residential & Commercial Expertise",
  "Credible & Timely Reports",
  "Certified Local Appraisers"
];

const stats = [
  { label: "Client Satisfaction", value: 98 },
  { label: "Personalized Solutions", value: 95 },
  { label: "Service You Can Rely On", value: 99 },
  { label: "Competitive Rates & Options", value: 96 }
];

const cards = [
  { icon: FiHome, title: "Residential", delay: 0.1 },
  { icon: FiBriefcase, title: "Commercial", delay: 0.2 },
  { icon: FiTrendingUp, title: "Investment Analysis", delay: 0.3 }
];

const WhyUs = () => {
  return (
    <section className="section-padding bg-offwhite">
      <div className="container-custom">
        
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-[2px] bg-gold"></div>
            <span className="text-gold font-semibold uppercase tracking-wider text-sm">Why Choose EPO Valuation?</span>
            <div className="w-8 h-[2px] bg-gold"></div>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold">Supporting Decisions for a Successful Future</h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-12 items-center">
          
          {/* Left Column - Cards & Features */}
          <div className="lg:col-span-7 space-y-10">
            {/* Interactive 3D Icon Cards */}
            <div className="grid sm:grid-cols-3 gap-4">
              {cards.map((card, idx) => (
                <motion.div 
                  key={idx}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: card.delay, duration: 0.5 }}
                  style={{ perspective: "1000px" }}
                >
                  <TiltCard>
                    <div className="card-base p-6 text-center hover:-translate-y-1 transition-transform duration-300 h-full">
                      <div className="w-14 h-14 mx-auto bg-navy/5 rounded-full flex items-center justify-center text-navy mb-4">
                        <SafeIcon icon={card.icon} className="w-6 h-6" />
                      </div>
                      <h3 className="font-serif font-bold text-lg">{card.title}</h3>
                    </div>
                  </TiltCard>
                </motion.div>
              ))}
            </div>

            {/* Features List */}
            <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
              <ul className="space-y-4">
                {features.map((feature, idx) => (
                  <motion.li 
                    key={idx}
                    initial={{ opacity: 0, x: -10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.4 + (idx * 0.1) }}
                    className="flex items-center gap-3 text-lg text-charcoal font-medium"
                  >
                    <SafeIcon icon={FiCheckCircle} className="text-gold w-6 h-6 flex-shrink-0" />
                    <span>{feature}</span>
                  </motion.li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right Column - Stats */}
          <div className="lg:col-span-5">
            <div className="space-y-8">
              {stats.map((stat, idx) => (
                <div key={idx} className="relative">
                  <div className="flex justify-between mb-2">
                    <span className="font-semibold text-navy">{stat.label}</span>
                    <span className="font-bold text-gold">{stat.value}%</span>
                  </div>
                  <div className="h-2.5 w-full bg-gray-200 rounded-full overflow-hidden">
                    <motion.div 
                      initial={{ width: 0 }}
                      whileInView={{ width: `${stat.value}%` }}
                      viewport={{ once: true, margin: "-50px" }}
                      transition={{ duration: 1.5, ease: "easeOut", delay: 0.2 }}
                      className="h-full bg-navy rounded-full relative"
                    >
                      <div className="absolute inset-0 bg-gradient-to-r from-transparent to-white/20"></div>
                    </motion.div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default WhyUs;